<script setup>
import {defineProps, defineEmits} from "vue"; //computed
import HeaderDeRecebimentos from "./HeaderDeRecebimentos.vue";
import BodyDeRecebimentos from "./BodyDeRecebimentos.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

const emits = defineEmits([
    "update:alteraRecebimento"
]);

//==================================================================//
//====================== Altera Recebimento ========================//
//==================================================================//

const alteraRecebimento = (update)=>{

    emits('update:alteraRecebimento',update);

};

</script>

<template>

    <v-card>

        <v-card-title class="c-card">

            <h3 class="c-card__titulo">
                Vinculos
            </h3>

        </v-card-title>

        <div class="c-table-wrapper">

            <div class="c-table">

                <HeaderDeRecebimentos
                    :dado="props?.dado"
                ></HeaderDeRecebimentos>

                <BodyDeRecebimentos
                    :dado="props?.dado"
                    @update:alteraRecebimento="alteraRecebimento"
                ></BodyDeRecebimentos>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

/*==================================================================*/
/*============================= Card ===============================*/
/*==================================================================*/

.c-card{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-card__titulo {
    grid-area: titulo;
}

.c-table-wrapper{
    overflow: hidden !important;
    width: calc(100vw - 24px);
    padding: 12px !important;
}

.c-table{
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

</style>